import 'twin.macro';
import React from 'react';
import { Tag } from '@teetsh/app/src/components/Tag';
import { LsuStatus } from '@teetsh/app/src/containers/Livrets/types/lsuStatus';
import {
  CheckIcon as Check,
  XMarkIcon as X,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  status?: LsuStatus;
  okLabel?: string;
  koLabel?: string;
}

export function LSUStatusBadge(props: Props) {
  const { status, okLabel, koLabel } = props;
  const { t } = useTranslation(['carnet']);
  if (!status) return null;
  if (status === 'ok') {
    return (
      <Tag color="green" icon={Check}>
        {okLabel || t('carnet:livret.lsuOkLabel')}
      </Tag>
    );
  }
  if (status === 'ko') {
    return (
      <Tag color="red" icon={X}>
        <span tw="truncate">
          {koLabel || t('carnet:livret.lsuMissingInformation')}
        </span>
      </Tag>
    );
  }
  return null;
}
